import React from "react";

import { useTranslation } from "react-i18next";

import TrendIndicator from "../../common/TrendIndicator/TrendIndicator";
import { buildComparisonSummary } from "../../utils/trendComparison";

const FinanceTrendSubtitle = ({
  comparison,
  countLabelKey,
  subtitle,
  testId = "finance-trend",
}) => {
  const { t } = useTranslation();
  const summary = buildComparisonSummary(comparison);

  if (!summary) {
    return <p className="text-xs text-gray-500 mt-1">{subtitle}</p>;
  }

  return (
    <div className="flex items-center flex-wrap gap-2 mt-1">
      <span
        className="text-sm font-medium text-gray-700"
        id={`${testId}-current-count`}
      >
        {t(countLabelKey, { count: summary.count })}
      </span>
      {summary.pill ? (
        <>
          <TrendIndicator
            trendValue={summary.pill}
            className="inline-flex"
            testId={`${testId}-delta`}
          />
          <span className="text-xs text-gray-500">
            {t("finance:issuance_trend_vs_previous", {
              count: summary.windowDays,
            })}
          </span>
        </>
      ) : (
        <span className="text-xs text-gray-500" id={`${testId}-no-previous`}>
          {t("finance:issuance_trend_no_previous")}
        </span>
      )}
    </div>
  );
};

export default FinanceTrendSubtitle;
